<template>
    <div>
        <CFormCheck
            v-for="option in options"
            :id="id"
            :key="option.label"
            v-model="option.value"
            type="radio"
            :name="id"
            :label="option.label"
            :checked="modelValue === option.value"
            @click="updateValue"
        />
    </div>
</template>

<script>
import { CFormCheck } from '@coreui/vue-pro'

export default {
    name: 'DRadioGroup',
    components: { CFormCheck },
    props: {
        options: {
            type: Object,
            default: () => {
                return {}
            }
        },
        id: {
            type: String,
            required: true
        },
        modelValue: {
            default: null,
            type: [String, Number]
        }
    },
    emits: ['update:modelValue'],
    methods: {
        updateValue (event) {
            this.$emit('update:modelValue', event.target.value)
        }
    }
}
</script>
